module.exports = __webpack_public_path__ + "static/media/mediMan.5fc15491.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/website/features/qmFeature/mediMan.jpg
// module id = 989
// module chunks = 0